module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.clientGroups.index.title')) + " (" + _vm._s(_vm.clientGroups.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "md": 16
    }
  }, [_c('div', {
    staticClass: "listOptions pull-right"
  }, [_c('v-text', {
    staticClass: "searchForm",
    attrs: {
      "name": "search",
      "type": "text",
      "translation": "search.title",
      "value": _vm.search
    },
    on: {
      "keydown": _vm.onChange
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('sort.title')) + " ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "sort",
      "options": _vm.sortTypes,
      "value": _vm.sort
    },
    on: {
      "change": _vm.onChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, [(_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "flex stretch wrap"
  }, [(_vm.clientGroups.items.length === 0) ? _c('v-no-data', [_vm._v("\n          " + _vm._s(_vm.$t('static.defaultText.clientGroup.noDataMsg')) + "\n          "), _c('router-link', {
    attrs: {
      "to": {
        name: 'clientGroups.create'
      }
    }
  }, [_vm._v("\n             "), _c('el-button', [_vm._v("\n              " + _vm._s(_vm.$t('static.defaultText.clientGroup.noDataBtn')) + "\n            ")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.clientGroups.items), function(p, i) {
    return _c('v-card', {
      key: i,
      nativeOn: {
        "click": function($event) {
          return _vm.editClientGroup(p)
        }
      }
    }, [_c('h2', {
      staticClass: "cardTitle"
    }, [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          return _vm.goToClients(p.id, $event)
        }
      }
    }, [_c('span', {
      staticClass: "cardLabel"
    }, [_vm._v("(" + _vm._s(p.clientsCount) + " " + _vm._s(_vm.$t('static.clientGroups.index.clientsCount')) + ")")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "cardinnerBox"
    }, [_c('div', [_c('label', {
      staticClass: "cardLabel cardLabel--small"
    }, [_c('i', {
      staticClass: "fa fa-file-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("  " + _vm._s(p.description || '-'))])])])])
  })], 2)]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
    staticClass: "pagination"
  }, [_c('v-pagination', {
    attrs: {
      "sizePerPage": _vm.perPage,
      "pagination": _vm.clientGroups.pagination,
      "switchFunction": _vm.all
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e0ca82a","hasScoped":false}!./src/app/pages/withNavigation/clientGroups/index/index.html
// module id = 2997
// module chunks = 1